import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  base_url, Apitoken, Authtoken  } from "../Global";
import $ from "jquery";
// import AWS from 'aws-sdk';
import { loader_image } from "../_components/Imagepath";
    let season_id = localStorage.getItem("season_id");

// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const ViewOrder = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [orderProgress, setOrderProgress] = useState('0.00%');
  const [permission, setPermission] = useState({});
  useEffect(() => {
        setPermission(FindModuleById(6)); 
        console.log(permission);
 
    axios.get(`/orders/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if(response.data.code === 200) {
          setValue(response.data.data.order);
          let order_detail = response.data.data.order;
          let order_progress = (order_detail.pallets_count / order_detail.total_number_of_pallets) *100;
          //console.log(order_progress.toFixed(4));
          setOrderProgress(order_progress.toFixed(2)+"%")
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleDownload = async () => {
    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    let season_id = localStorage.getItem("season_id");
    axios.get(`/orders/pdf/${season_id+'-'+id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let file_name = value?.po_number ? `${value.po_number}.pdf` : "default.pdf";
        link.download = file_name;
        link.click();
        $("#loader-image").addClass('loader-hide');
        $("#loader-image").removeClass('loader-show');
    }).catch(error => {
        console.error('Error downloading PDF:', error);
    });
};
const editItem = ()=>{
  window.location.href = "/orders-edit/"+id;
}
   
const downloadExcel = (e) => {

  console.log(e);
  let season_id = localStorage.getItem("season_id");

  $("#loader-image2").removeClass('loader-hide2');
  $("#loader-image2").addClass('loader-show2');
            window.open(`${base_url}/production-orders/final-pallets-listing-excel/${season_id+'-'+id}`, '_blank');

            $("#loader-image2").addClass('loader-hide2');
            $("#loader-image2").removeClass('loader-show2');
           
     
}
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Orders</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/orders">Orders</Link>
                    </li>
                    <li className="breadcrumb-item active">View Order</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                {permission?.list == 1 && (
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">View Order Info</h4>
                      <div style={{float:"right"}}>

                        <button   onClick={() => editItem()}   className="btn btn-danger me-1"  > Edit Order    </button>
                   
                        <button   onClick={() => handleDownload()}   className="btn btn-primary me-1"  > Print Order <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>  </button>
                      &nbsp;&nbsp;
                                        <button
                                           className="btn btn-primary"
                                           onClick={() => downloadExcel()}
                                         >
                                           <i className="fa fa-file-excel-o"></i> Excel <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                                         </button>
                      </div>
                      <table className="table table-bordered">
                      <tbody>
                      <tr>
                          <th className="p-3">PO Number</th>
                          <td className="p-3">{value.po_number}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Order Progress</th>
                          <td className="p-3">{orderProgress}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Customer</th>
                          <td className="p-3">
                            {value.customer ? value.customer.company_name : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">ETA Week</th>
                          <td className="p-3">{value.eta_week}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Exportator Number</th>
                          <td className="p-3">{value.exportator_number}</td>
                        </tr>


          
                      
                        <tr>
                          <th className="p-3">Shipping Method</th>
                          <td className="p-3">
                            {value.ship_method ? value.ship_method.title : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Shipping Address</th>
                          <td className="p-3">
                            {value.ship_address
                              ? value.ship_address.name
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Production Location</th>
                          <td className="p-3">
                            {value.order_location ? value.order_location.title : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Broker</th>
                          <td className="p-3">
                            {value.broker_detail
                              ? value.broker_detail.broker_name
                              : ""}
                          </td>
                        </tr>
                       
                        <tr>
                          <th className="p-3">Order Status</th>
                          <td className="p-3">
                            {value.status ? value.status.title : ""}
                          </td>
                        </tr>
                         <tr>
                              <th className="p-3">Total Net Weight</th>
                              <td className="p-3">{value.packaging_total_net_weight} KG</td>
                            </tr>
                        <tr>
                          <th className="p-3">Remarks</th>
                          <td className="p-3">{value.remarks}</td>
                        </tr>
                        </tbody>
                      </table>
                      <br />
                      <h5 className="card-title">Order Items: {(value.total_number_of_pallets && value.total_number_of_pallets)?value.total_number_of_pallets:0}</h5>

                      <table className="table table-bordered">
                        <tr>
                          <th className="p-3">Number of pallets</th>
                          <th className="p-3">Product</th>
                          <th className="p-3">Caliber</th>
                          <th className="p-3">Packaging Type</th>
                          <th className="p-3">Pallet Type </th>
                          <th className="p-3">Price </th>
                          {/* <th className="p-3">Boxes</th> */}
                          {/* <th className="p-3">Amount </th> */}
                        </tr>

                        {value.contents &&
                          value.contents.map((item, indx) => (
                            <tr  key={item.pallet_number || indx}>
                              <td className="p-3">{item.pallet_number}</td>
                              <td className="p-3">{item.product_name}</td>
                              <td className="p-3">{item.calibre}</td>
                              <td className="p-3">{item.packaging_type_name}</td>
                              <td className="p-3">{item.pallet_type_name}</td>
                              
                              <td className="p-3">{item.price.toFixed(4)}{value.customer_currency}</td>
                              {/* <td className="p-3">{item.number_of_boxes}</td> */}
                              {/* <td className="p-3">{parseFloat(item.item_total).toFixed(4)}{value.customer_currency}</td> */}
                            </tr>
                          ))}
                      </table>
                          
                      <br />
                      <h5 className="card-title">Finalised Pallets: {(value.pallets_count && value.pallets_count)?value.pallets_count:0}</h5>
                      
                        {/* <table className="table table-bordered text-center">
                          <tr>
                            <th className="p-3 ">Barcode Number</th>
                            <th className="p-3">Product</th>
                            <th className="p-3">Shift</th>
                            <th className="p-3">Caliber </th>
                            <th className="p-3">Number of boxes </th>
                          </tr>
                            {value.final_productions && value.final_productions.map((item_pallet, indx) => (
                                  <tr   key={item_pallet.product_name || indx}>
                                    <td className="p-3">
                                      <a href={'/production-output-view/'+item_pallet.productions_output_id} className="btn btn-primary btn-link"  >
                                        {item_pallet.barcode_number}
                                      </a>
                                      </td>
                                      <td className="p-3">{item_pallet.product_name}</td>
                                      <td className="p-3">{item_pallet.shift}</td>
                                    <td className="p-3">{item_pallet.calibre}</td>
                                    <td className="p-3">{item_pallet.number_of_boxes}</td>
                                  </tr>
                              ))}
                      </table> */}
                      <table className="table table-bordered text-center">
                   <tr>
                     <th className="p-3 ">Barcode Number</th>
                     <th className="p-3">Product</th>
                     <th className="p-3">Lot Number</th>
                     <th className="p-3">Raw Material Lot Number</th>
                    <th className="p-3">Production Date Time</th>
                    <th className="p-3">Shift</th>
                     <th className="p-3">Caliber </th>
                     <th className="p-3">Number of boxes </th>
                     <th className="p-3">Packaging Type </th>
                     <th className="p-3">Net Weight </th>
                   </tr>
                     {value.final_productions && value.final_productions.map((item_pallet, indx) => (
                           <tr  key={item_pallet.product_name || indx}>
                             <td className="p-3">
                               <a href={'/production-output-view/'+item_pallet.productions_output_id} className=""  >
                                 {item_pallet.barcode_number}
                               </a>
                               </td>
                               <td className="p-3">{item_pallet.product_name}</td>
                               <td className="p-3">{item_pallet.lot_number_total}</td>
                               <td className="p-3">{item_pallet.total_raw_material_lot_number}</td>
                               <td className="p-3">{item_pallet.date_time}</td>
                               <td className="p-3">{item_pallet.shift}</td>
                             <td className="p-3">{item_pallet.calibre}</td>
                             <td className="p-3">{item_pallet.number_of_boxes}</td>
                             <td className="p-3">{item_pallet.packaging_type_title}</td>
                             

                             <td className="p-3">{item_pallet.net_weight}</td>
                           </tr>
                       ))}
               </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewOrder;
